/**
 * The address of SkyMap Id's profile page that brings the user back to
 * `returnTo` when they are done. The page honours `return_to` only when its
 * origin is a redirect URI of our registration (identity-service
 * docs/profile-page.md), so this must be our own origin; otherwise the page
 * simply shows no way back.
 */
export function profileHref(profileUrl: string, returnTo: string): string {
  const url = new URL(profileUrl);
  url.searchParams.set('return_to', returnTo);
  return url.toString();
}
